// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2JcrF","right":"Footer_right__39Jc0","buttons":"Footer_buttons__oTnrF"};